module.exports = __webpack_public_path__ + "static/media/ndpr.411010b5.png";